import React from 'react';
import cx from 'classnames';

import level_1 from 'assets/images/adaptive/levels/level-1.png';
import level_1_fidelity_low from 'assets/images/adaptive/levels/level-1_fidelity-low.png';
import level_2 from 'assets/images/adaptive/levels/level-2.png';
import level_2_fidelity_low from 'assets/images/adaptive/levels/level-2_fidelity-low.png';
import level_3 from 'assets/images/adaptive/levels/level-3.png';
import level_3_fidelity_low from 'assets/images/adaptive/levels/level-3_fidelity-low.png';
import {Level1Empty} from 'assets/images/adaptive/levels/Level1Empty';
import {Level2Empty} from 'assets/images/adaptive/levels/Level2Empty';
import {Level3Empty} from 'assets/images/adaptive/levels/Level3Empty';

import './level-badge.scss';

interface LevelBadgeProps {
  className?: string;
  width?: number | string;
  height?: number | string;
  levelNum?: 1 | 2 | 3;
  fidelity?: 'low' | 'default';
  empty?: boolean;
}

export const LevelBadge = ({
  className = '',
  width = 24,
  height = 24,
  levelNum = 1,
  empty = false,
  fidelity = 'default'
}: LevelBadgeProps) => {
  // For empty state, render SVG components
  if (empty) {
    const EmptyBadgeComponent =
      {
        1: Level1Empty,
        2: Level2Empty,
        3: Level3Empty
      }[levelNum] || Level1Empty;

    return (
      <EmptyBadgeComponent
        width={width}
        height={height}
        className={cx('empty-badge-component fill-content-primary', className)}
      />
    );
  }

  // For filled and low fidelity states, render PNG images
  const imageSrc = () => {
    if (fidelity === 'low') {
      switch (levelNum) {
        case 1:
          return level_1_fidelity_low;
        case 2:
          return level_2_fidelity_low;
        case 3:
          return level_3_fidelity_low;
        default:
          return level_1_fidelity_low;
      }
    }

    switch (levelNum) {
      case 1:
        return level_1;
      case 2:
        return level_2;
      case 3:
        return level_3;
      default:
        return level_1;
    }
  };

  return <img alt='' src={imageSrc()} style={{width, height}} className={className} />;
};

export default LevelBadge;
